import { render, staticRenderFns } from "./salesInvoiceHistory.vue?vue&type=template&id=7f20af40&scoped=true"
import script from "./salesInvoiceHistory.vue?vue&type=script&lang=js"
export * from "./salesInvoiceHistory.vue?vue&type=script&lang=js"
import style0 from "./salesInvoiceHistory.vue?vue&type=style&index=0&id=7f20af40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f20af40",
  null
  
)

export default component.exports